import * as React from 'react';
import styled from 'styled-components';

interface Props {
    locationName: string;
    color?: string;
}

const Title: React.SFC<Props> = ({ locationName, color }) => (
    <Wrapper>
        <H1>{locationName}</H1>
    </Wrapper>
);

export default Title;

const Wrapper = styled.div`
    text-align: center;
    padding-bottom: 1.5em;
`;

const H1 = styled.h1`text-align: center;`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Conversation/Mobile/Title.tsx